import { useEffect, useState } from 'react';
import { authManager } from 'src/services/authManager';

export function useAuth() {
    const [isAuthenticated, setIsAuthenticated] = useState(
        Boolean(localStorage.getItem('tokens')),
    );

    useEffect(() => {
        console.log('[useAuth] Subscribing to authManager state.');

        // Subscribe to the authManager's state
        const subscription = authManager.isAuthenticated$.subscribe((state) => {
            console.log('[useAuth] Auth state updated:', state);
            setIsAuthenticated(state);
        });

        // Sync with localStorage on mount
        authManager.syncWithLocalStorage();

        // Cleanup subscription on unmount
        return () => {
            console.log('[useAuth] Unsubscribing from authManager state.');
            subscription.unsubscribe();
        };
    }, []);

    return isAuthenticated;
}
